import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast, ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import logoImage from "./assets/GX Transparent logo.png";
import BgImage from "./assets/lgbg.jpg";
import hrLogo1 from "./assets/hrlogo2.png";

const SignInWithHR = () => {
  const [submitted, setSubmitted] = useState(false);
  const [cookies, setCookie] = useCookies(["authToken", "userName", "role", "team"]);
  const navigate = useNavigate();

  const schema = yup.object().shape({
    email: yup.string().required("Email is required").email("Email is invalid"),
    password: yup.string().required("Password is required").min(8, "Password must be at least 8 characters"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    try {
      const response = await fetch("http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/SignInWithHR", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      const responseData = await response.json();

      if (response.ok) {
        setCookie("authToken", responseData.refreshToken, { path: "/", maxAge: 86400 });
        setCookie("userName", responseData.user.userName, { path: "/", maxAge: 86400 });
        setCookie("role", responseData.user.role, { path: "/", maxAge: 86400 });
        setCookie("team", responseData.user.team, { path: "/", maxAge: 86400 });

        toast.success("Signed in successfully!", {
          position: "top-center",
          transition: Slide,
        });

        reset();
        setSubmitted(true);
      } else {
        toast.error(responseData.error || "Incorrect email or password.");
      }
    } catch (error) {
      console.error("Sign-in error:", error);
      toast.error("An error occurred. Please try again.");
    }
  };

  useEffect(() => {
    if (submitted) {
      const timer = setTimeout(() => {
        navigate("/dashboard/create-candidate-account");
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [submitted, navigate]);

  return (
    <div className="relative min-h-screen flex items-center justify-center bg-cover bg-center" style={{ backgroundImage: `url(${BgImage})` }}>
      <ToastContainer />

      {/* Top Right Logo */}
      <img src={logoImage} alt="GX Logo" className="absolute top-4 right-6 w-48 md:w-60" />

      {/* Left HR Logo */}
     

      {/* Sign-In Form */}
      <div className=" relative z-10 bg-white bg-opacity-10 backdrop-blur-md rounded-2xl shadow-lg px-8 py-10 w-full max-w-md mx-4 md:mx-0">
    

        <h2 className="text-3xl font-bold text-white text-center mb-6 tracking-wide">HR Portal Login</h2>
        {/* <img
  src={hrLogo1}
  alt="HR Logo"
  className="absolute -top-16 left-1/2 transform -translate-x-1/2 w-24 md:w-32"
/> */}

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
          {/* Email */}
          <div>
            <label htmlFor="email" className="block text-white mb-1 font-medium">Email</label>
            <input
              id="email"
              type="email"
              {...register("email")}
              className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 outline-none"
            />
            {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email.message}</p>}
          </div>

          {/* Password */}
          <div>
            <label htmlFor="password" className="block text-white mb-1 font-medium">Password</label>
            <input
              id="password"
              type="password"
              {...register("password")}
              className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 outline-none"
            />
            {errors.password && <p className="text-red-500 text-sm mt-1">{errors.password.message}</p>}
          </div>

          {/* Submit */}
          <button
            type="submit"
            className="w-full bg-blue-600 text-white font-semibold py-2 rounded-lg hover:bg-blue-700 transition duration-300"
          >
            Log In
          </button>
        </form>
      </div>
    </div>
  );
};

export default SignInWithHR;
